import React, { useState, useEffect } from 'react'
import { Col, Icon, IconButton, Panel, Row } from 'rsuite'
import { startLoading, doneLoading } from '../../../utils/loading'
import ListOfAssetsFormSearch from './ListOfAssetsFormSearch'
import ListOfAssetsTable from './ListOfAssetsTable'
import notification from '../../../utils/notification'
import { DEFAULT_ERR_MSG } from '../../../constants/msgText'
import { cloneDeep } from 'lodash'
import { searchListOfAssets } from '../../../redux/actions/listOfAssets'

export default function AssetQrCodeReportWidget(props) {
  const { projectCode } = props

  const [isLoading, setIsLoading] = useState(false)
  const [formSchema, setFormSchema] = useState(props.schema)
  const [displayLength, setDisplayLength] = useState(5)
  const [page, setPage] = useState(1)
  const [searchRequest, setSearchRequest] = useState({})

  const handleSearch = async (pagenumber, pagesize, request) => {
    setIsLoading(true)
    startLoading()
    try {
      console.log(pagenumber, pagesize, request)
      setPage(pagenumber)
      setDisplayLength(pagesize)
      setSearchRequest(request)

      const response = await searchListOfAssets(projectCode, request, pagenumber, pagesize)
      // console.log('response ', response)
      if (response) {
        let _schema = cloneDeep(formSchema)

        _schema.result = response.model
        setFormSchema(_schema)
      } else {
        notification.open('error', {
          title: DEFAULT_ERR_MSG,
          duration: 5000,
        })
      }
    } catch (e) {
      console.log('error', e)
      notification.open('error', {
        title: DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    doneLoading()
    setIsLoading(false)
  }

  const onReload = (pagenumber, pagesize) => {
    handleSearch(pagenumber, pagesize, searchRequest)
  }

  const onSearch = (request) => {
    handleSearch(1, displayLength, request)
  }

  return (
    <>
      <Panel shaded bordered>
        {formSchema?.searchForm && (
          <div style={{ marginTop: 0 }}>
            <ListOfAssetsFormSearch
              schema={formSchema.searchForm}
              onSearch={onSearch}
              loading={isLoading}
            />
          </div>
        )}

        <ListOfAssetsTable
          schema={formSchema?.result}
          loading={isLoading}
          onReload={onReload}
          page={page}
          displayLength={displayLength}
        />
      </Panel>
    </>
  )
}
